import * as Yup from "yup";

export const FiscalYearFormValidation = Yup.object({
    year: Yup.number()
        .typeError("Fiscal year must be a number")
        .required("Fiscal year is required")
        .integer("Fiscal year must be a whole number")
        .min(2000, "Fiscal year must be 2000 or later")
        .max(2100, "Fiscal year must be 2100 or earlier"),
});
